import axios from 'src/api/Api';
import { put } from 'redux-saga/effects';
import { GET_ACCOUNTS_SUCCESS, GET_ACCOUNTS_FAILURE } from '../actions';

import { errorHandler } from 'src/errorHandler/errorHandler';
import { convertObjectToQueryParams } from 'src/utils/util';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getAccount(action) {
    const params = convertObjectToQueryParams({
        ...action.payload,
    });

    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/aardt/accounts?orderType=&${params}`;

    try {
        const result = yield axios.get(url).then((response) => response.data);

        if (result.accounts?.length > 0) {
            const accountsLists = result.accounts.map((account) => {
                return {
                    ...account,
                    id: account.accountId,
                    name: account.accountName,
                };
            });

            result.accounts = [...accountsLists];
        }

        yield put({ type: GET_ACCOUNTS_SUCCESS, data: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_ACCOUNTS_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
